import React from 'react';
import { Route, Switch, Redirect } from 'react-router';
import Section from 'jsx/elements/section/Section';

import Dashboard from 'pages/Dashboard';
import Portfolio from 'pages/Portfolio';

export default function PortfolioRoot() {
  return (
    <Section>
      <Switch>
        <Route path="/" exact component={Dashboard} />
        <Route path="/portfolio" component={Portfolio} />
        <Route
          path="/monitoring"
          render={({ location }) => {
            return <Redirect to={{ pathname: '/', search: location.search }} />;
          }}
        />
      </Switch>
    </Section>
  );
}
